import * as React from 'react';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import { Box, Button, DialogActions, Divider, Grid, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { getConfigFile } from 'API/Config/api';
import {
    // ApproveReuploadRequest,
    DownloadImages2,
    GetFieldData, GetFieldDataFromKyc, getImagesCSPkyc, SendReuploadFile
} from 'API/Approval/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import ImageModal from '../Approval/Components/ImageModal';
// import { Stack } from '@mui/system';
import { styled } from '@mui/material/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DynamicBankAccNumberVerify, DynamicGet, getDynamicDataWithParams, PostDynamicData } from 'API/UserList/CspList';
import { EditUserData } from 'API/AecOnboarding/api';
import { IoMdDownload } from "react-icons/io";
import { Getstates } from 'API/DsOnboarding/api';






const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function DocumentModal(props) {
    const [configData, setConfigData] = useState(null)
    const [FilteredData, setFilteredData] = useState(null)

    const [Selected, setSelected] = useState(null)
    const [UserData, setUserData] = useState(null)
    const [open, setOpen] = React.useState(false);
    const [AlertMessage, setAlertMessage] = useState("")
    const [AlertType, setAlertType] = useState('success')
    const [Image, setImage] = useState(null)
    const [OpenImage, setOpenImage] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [fileType, setFileType] = useState(null)
    const [PostData, setPostData] = useState({})
    const [DocumentUploadedData, setDocumentUploadedData] = useState({})
    const [unavailableKeys, setUnavailableKeys] = useState([]);
    const [IsError, setIsError] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState({})
    const [, forceRender] = useState(false);

    const [DynamicData, setDynamicData] = useState(null);
    const [Lastcall, setLastCall] = useState(null);
    const [VerificationStatus, setVerificationStatus] = useState({
        isVerificationAvailable: false,
        isChanged: false,
        isVerified: false,
    });

    // test



    const zip = new JSZip();


    const getVerificationStatus = () => {
        return (
            Selected && Selected.fields?.some(
                (field) => (field.field_type === "Plugin" && field.field_details?.verify) === "true"
            ) || false
        );
    };

    console.log("Selected", Selected, props.data);


    useEffect(() => {
        forceRender(prev => !prev);
    }, []);

    useEffect(() => {
        console.log(props);

        if (props.open) {
            console.log("closed triggerr");

            setVerificationStatus({
                isVerificationAvailable: false,
                isChanged: false,
                isVerified: false,
            })
            setPostData(() => ({ ...{} })); // Ensures a new object is created
            setErrorMessage({})
            setIsError(false)
        }
    }, [])


    useEffect(() => {
        const status = getVerificationStatus();
        console.log("status", status);

        setVerificationStatus((prevState) => ({
            ...prevState,
            isVerificationAvailable: status,
        }));
    }, [props]);


    const handleAlertOpen = (message, type) => {
        setAlertMessage(message);
        setAlertType(type);
        setOpen(true);
    }


    const handleOpenImage = () => {
        setOpenImage(true)
    }

    const handleCloseImage = () => {
        setOpenImage(false)
    }

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const [DummyData, setDummyData] = useState()
    const [AllData, setAllData] = useState()

    useEffect(() => {
        if (Selected) {
            let filter = Selected["fields"]
                .map(field => {
                    if (field.field_type !== "Documents" && field.required) {
                        return field.field_name;
                    } else if (field.field_type === "Documents" && field.required) {
                        return field.field_name;
                    }
                    return undefined;
                })
                .filter(fieldName => fieldName !== undefined);
    
            setDummyData(filter);
        }
    }, [Selected]);
    



    useEffect(() => {
        if (DummyData && props.open) {
            GetFieldData(setAllData, DummyData, props.data.user_id)
        }
    }, [DummyData])



    const handleFormOpen = (category) => {
        setSelected(category)
    }

    useEffect(() => {
        setSelected(null)
        setPostData({})
    }, [props.handleClose])

    console.log("props", props);

    const handleDownloadFile = (field, name) => {
        let url = UserData[0][field]
        DownloadImages2(url, name, handleAlertOpen, setIsLoading)
    }



    const handleViewFile = (field) => {
        let url = UserData[0][field]
        console.log("asdas", UserData);

        getImagesCSPkyc(url, setImage, handleOpenImage, handleClick, setFileType, setIsLoading)
    }

    useEffect(() => {
        if (props.data && configData) {
            let filter = configData.filter((item) => item._id === props.data.product_id)
            console.log("filter", filter, props);

            let temp = filter && filter.length > 0 && filter[0].flow === 3 ? filter[0].categories : null
            let category = temp && temp.filter((item) => item.category_name.includes("nominee") === false && item.category_name.includes("home") === false)
            setFilteredData(category)

        }
        {
            if (!props.data) {
                props.handleClose()
            }
        }
    }, [props.data, configData, UserData])

    useEffect(() => {
        getConfigFile(setConfigData)
        Getstates(setDynamicData)
    }, [])

    const getFieldsValue = () => {
        if (Selected && props.open) {
            let userdata = Selected.fields.map(item => item.field_name)
            GetFieldDataFromKyc(setUserData, userdata, props.data.user_id, setIsLoading)
            // props.handleGetList()
        }
    }


    const IsEmpty = () => {


        return Object.keys(PostData).length === 0;

    }



    useEffect(() => {

        getFieldsValue()
        setPostData({})
    }, [Selected])


    const handleBack = () => {
        setSelected(null)
    }

    const handleDateChange = (value, field_name) => {
        setPostData({ ...PostData, [field_name]: value })
    }

    const handleListChange = (value, field_name) => {
        let updatedData = { ...PostData };
        updatedData[field_name] = value;
        setPostData(updatedData)
    }

    const handleDataChange = (value, field_name, field_details) => {
        console.log("details", field_details, value, field_name);
        let updatedData = { ...PostData };
        setIsError(false)
        setErrorMessage({ ...ErrorMessage, [field_name]: "" })
        if (value !== "" && value.trim() === "") return;

        if (field_name === 'email_address' && /^[a-zA-Z0-9@_.]*$/.test(value)) {
            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {

                updatedData[field_name] = value;
            }
            else {
                setIsError(true)
                setErrorMessage({ ...ErrorMessage, [field_name]: 'Invalid Email Address' })
                updatedData[field_name] = value;
            }
        } else if (field_name === 'csp_type') {
            updatedData[field_name] = value;
            updatedData['csp_code'] = null;
        }

        else if (field_name.toLowerCase().includes("ifsc") || (field_details && field_details.verify === "true")) {
            setVerificationStatus({ ...VerificationStatus, isChanged: true, isVerified: false })
            if ((field_details && field_details.verify === "true")) {
                console.log("im here", value, value.length < 25 && /^[0-9]*$/.test(value));
                if (value.length < 25 && /^[0-9]*$/.test(value)) {
                    updatedData[field_name] = value;
                }
                else {
                    return;
                }
            }
            else {
                if (/^[A-Za-z]{4}0[A-Z0-9]{6}$/.test(value)) {
                    setErrorMessage({ ...ErrorMessage, [field_name]: "" })
                    setIsError(false)
                    updatedData[field_name] = value.toUpperCase();
                }
                else {
                    setIsError(true)
                    setErrorMessage({ ...ErrorMessage, [field_name]: 'Invalid IFSC Code' })
                    updatedData[field_name] = value.toUpperCase();
                }
            }
        }

        else {
            const regexPattern = field_details?.Regex ? new RegExp(field_details.Regex) : /^[a-zA-Z0-9\s]*$/;
            const maxLength = field_details?.maxLength ? Number(field_details.maxLength) : 20;
            const minLength = field_details?.minLength ? Number(field_details.minLength) : 0;

            if (value.length < minLength) {
                setIsError(true)
                setErrorMessage({ ...ErrorMessage, [field_name]: 'Value must have minimum length of ' + minLength })
            }

            const isValid = regexPattern.test(value) && value.length <= maxLength;

            if (isValid) {
                updatedData[field_name] = value;
            } else {
                console.log("Validation failed:", value);
            }
        }

        setPostData(updatedData);
    }



    useEffect(() => {
        if (unavailableKeys.length > 0) {
            console.log('trigger');

            const foundCategoryNames = unavailableKeys.reduce((acc, field) => {
                FilteredData.forEach(obj => {
                    const isFieldAbsentInOtherCategories = !FilteredData.some(category =>
                        category.fields.some(f => f.field_name === field) && category.category_display_name !== obj.category_display_name
                    );

                    if (isFieldAbsentInOtherCategories && !acc.includes(obj.category_display_name)) {
                        acc.push(obj.category_display_name);
                    }
                });
                return acc;
            }, []);

            console.log(foundCategoryNames);

            if (foundCategoryNames.length > 0) {
                setAlertMessage(`Please fill all required fields in ${foundCategoryNames.join(', ')}`);
                setAlertType('error');
                handleClick();
            }
        }
    }, [unavailableKeys]);




    const handleFileReupload = (name, file) => {

        let maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            setAlertMessage("File size should be less than 5MB")
            setAlertType("error")
            handleClick()

        }
        else if (!['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)) {
            setAlertMessage("Invalid file type. Please upload either .jpeg, .png or PDF")
            setAlertType("error")
            handleClick()
        }
        else {

            SendReuploadFile(file, name, props.data.user_id, setAlertMessage, setAlertType, handleClick, getFieldsValue, setIsLoading, setDocumentUploadedData, DocumentUploadedData)
        }
    }



    function checkKeys(requiredKeys, obj1, obj2, obj3,obj4) {
        setIsLoading(true);

        const exceptions = ["mobile_number_2", "ssa_name", "mobile_number_2", "home_landmark"];
        const keysNotAvailable = [];

        const result = requiredKeys.every(key => {
            if (!exceptions.includes(key)) {
                if (key === 'csp_code') {
                    if (PostData['csp_type'] && PostData['csp_type'] !== 'new') {
                        const isAvailable = (key in obj1 && obj1[key]) || (key in obj2 && obj2[key] || (key in obj3 && obj3[key])|| (key in obj4 && obj4[key]))
                        if (!isAvailable) {
                            keysNotAvailable.push(key);
                        }
                        return isAvailable;
                    }

                }
                else {
                    const isAvailable = (key in obj1 && obj1[key]) || (key in obj2 && obj2[key] || (key in obj3 && obj3[key])|| (key in obj4 && obj4[key]));
                    if (!isAvailable) {
                        keysNotAvailable.push(key);
                    }
                    return isAvailable;
                }

            }
            return true;
        });

        setUnavailableKeys(keysNotAvailable);
        setIsLoading(false);
        return result;
    }

    console.log("unavailable keys: " + unavailableKeys,Selected,DummyData);
    
   


    const GetCategory = () => {
        let status = Selected && (Selected.category_name.includes("aec") || Selected.category_name.includes("retail") || Selected.category_name.includes("activation")||Selected.category_name.includes("kyc"))
        return status
    }




    const url = process.env.REACT_APP_APPROVAL_URL;
    const handleFileDownloadAll = async () => {
        setIsLoading(true);

        try {
            const downloadPromises = Object.entries(UserData[0]).map(async ([key, value]) => {
                if (value) {
                    try {
                        const response = await axios.post(`${url}/download`, { url: value }, { responseType: 'arraybuffer' });
                        if (response.status === 200) {
                            const contentType = response.headers['content-type'];
                            let fileExtension = key;
                            if (contentType === 'application/pdf') {
                                fileExtension = `${key}.pdf`;
                            } else if (contentType.startsWith('image/')) {
                                fileExtension = `${key}.jpg`;
                            } else {
                                fileExtension = `${key}.bin`;
                            }
                            zip.file(fileExtension, response.data);
                        } else {
                            throw new Error('Network response was not ok.');
                        }
                    } catch (error) {
                        console.error(`Error downloading file ${key}:`, error);
                    }
                }
            });

            await Promise.all(downloadPromises);
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            saveAs(zipBlob, `${props.data.agent_code ? props.data.agent_code : ''}.zip`);
        } catch (error) {
            alert('Error downloading multiple images');
            console.error('Error downloading multiple images:', error);
        } finally {
            setIsLoading(false);
        }
    }

    const shouldDisplay = (field) => {
        if (field.field_name === 'csp_code') {
            const isUserDataValid = UserData && UserData[0] && UserData[0]['csp_type'] !== 'new' && !PostData['csp_type'];
            const isPostDataValid = PostData && PostData['csp_type'] && PostData['csp_type'] !== 'new';

            return isUserDataValid || isPostDataValid;
        }
        else {
            return (field.required === 'true' || field.required) && field.field_name !== 'csp_code';
        }
    };


    const getMatch = (value, string) => {
        console.log(value, string, value.includes(string));
        return value.includes(string);
    };
    // getMatch()

    const getKey = (obj, searchString) => {
        console.log(obj, searchString);
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) && key.toUpperCase().includes(searchString.toUpperCase())) {
                return key;
            }
        }
        return null;
    };


    function checkValues() {
        for (let key in ErrorMessage) {
            if (ErrorMessage[key] !== "") {
                return true;
            }
        }
        return false;
    }

    console.log("props: " + props);

    function checkAllValues() {
        for (let key in PostData) {
            if ((PostData[key] === "")) {
                let field = Selected.fields.find(item => item.field_name === key)
                if (field && field.required) {
                    return true;
                }
            }
        }
        return false;
    }


    const handleSubmit = () => {
        let errorStatus = checkValues()
        let modifiedData = checkAllValues()
        if (errorStatus) {
            handleAlertOpen("Unable to submit as there are some errors in the form", "error")
            return
        }
        else if (Object.getOwnPropertyNames(PostData).length === 0) {
            props.handleClose()
        }
        else if (modifiedData) {
            handleAlertOpen("Please fill all the required fields", "error")
            return
        }
        else if (VerificationStatus.isVerificationAvailable === true && VerificationStatus.isChanged === true && VerificationStatus.isVerified === false) {
            handleAlertOpen("Please fill the fields if required", "error")
            return
        }
        else {
            const isAllPresent = checkKeys(DummyData, AllData[0], PostData, DocumentUploadedData,props.data[Selected["category_name"]])
            if(isAllPresent){

                EditUserData(PostData, setPostData, props.data.user_id, setIsLoading, handleAlertOpen, getFieldsValue, setSelected, props.handleGetList)
            }
            else{
                handleAlertOpen("Please fill all the required fields", "error")
            }
        }
    }


    const handlePluginButton = (name, value, details) => {
        // console.log('clicked');
        // console.log(name);
        // console.log(value);
        // console.log(details.body[0]['value']);
        if (value[name] || value[details.body[0]['value']]) {
            switch (details.method) {
                case 'POST': {
                    if (details.field_required) {
                        if (details.verify) {
                            DynamicBankAccNumberVerify(
                                value[details.body[0]['value']] ? value[details.body[0]['value']] : UserData[0][details.body[0]['value']],
                                value[name] ? value[name] : UserData[0][name],
                                name,
                                details.body[0]['fetch'],
                                handleAlertOpen,
                                setIsLoading,
                                setPostData,
                                details.body[0]['value'],
                                PostData,
                                setVerificationStatus
                            );
                        }
                    }
                }
            }
        }
        else {
            handleAlertOpen("Bank Details are not modified", "error")
        }

    };


    const handleDynamicGet = (field, params, values) => {
        // console.log(values);
        console.log('para', field);
        if (field.field_name !== Lastcall) {
            console.log('field', field);
            if (field.field_details.parameters) {
                let postparams = {};
                params.forEach((field) => {
                    console.log(field);
                    if (typeof field === 'object') {
                        Object.entries(field).map(([key, value]) => {
                            console.log(key);
                            console.log(value);
                            let split = value.split('_');
                            // let tt = field
                            postparams[split[split.length - 1].toLowerCase()] = values[value] ? values[value] : UserData && UserData.length > 0 && UserData[0] ? UserData[0][value] : "";
                        });
                    } else {
                        let split = field.split('_');
                        let key = field;
                        postparams[split[split.length - 1].toLowerCase()] = values[key] ? values[key] : UserData && UserData.length > 0 && UserData[0] ? UserData[0][key] : "";
                    }

                    // console.log(split);
                    // console.log(key);
                });
                switch (field.field_details.method) {
                    case 'GET':
                        console.log('params');
                        getDynamicDataWithParams(field, postparams, setDynamicData);
                        setLastCall(field.field_name);
                        break;

                    // case 'POST':
                    //         console.log('params');
                    //         // PostDynamicDataWithParams(field, postparams, setDynamicData);
                    //         setLastCall(field.field_name);
                    //         break;
                }
            } else {
                console.log('fsdfsdfsdfds called');
                switch (field.field_details.method) {
                    case 'GET':
                        console.log('normal');
                        DynamicGet(field, setDynamicData);
                        setLastCall(field.field_name);

                        break;
                    case 'POST':
                        console.log('params');
                        PostDynamicData(field, setDynamicData);
                        setLastCall(field.field_name);
                        break;
                    default:
                        break;
                }
            }
        }
    };



    console.log("postdata", PostData, DynamicData, UserData);


    return (
        <React.Fragment >


            <Snackbar anchorOrigin={{ horizontal: 'right', vertical: 'top' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={AlertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {AlertMessage}
                </Alert>
            </Snackbar>

            <ImageModal fileType={fileType} image={Image} open={OpenImage} handleClose={handleCloseImage} />

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={Selected ? 'lg' : 'xs'}

            >

                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: Selected ? 'none' : 'block'
                    }}
                    onClick={props.handleClose}
                >
                    <IoClose />
                </Box>
                <DialogContent sx={{ width: '100%', height: Selected ? '80vh' : '100%', scrollbarWidth: 'none' }}>
                    {
                        Selected ?
                            <Grid container spacing={2} paddingInline={2}>
                                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Box sx={{
                                        position: 'absolute',
                                        top: 10,
                                        right: 10,
                                        fontSize: '24px',
                                        cursor: 'pointer',
                                    }} variant='outlined' onClick={() => handleBack()}><IoClose /></Box>
                                </Grid>

                                {
                                    Selected.fields.map((field, index) => (
                                        field.field_type === 'Text' || field.field_type === 'Function Call' || field.field_type === 'bankname' || field.field_type === 'bankifsc' ?
                                            <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                    color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                }}>*</span></Typography>
                                                <TextField
                                                    variant='outlined'
                                                    value={(props.type !== 'rejected' && (PostData[field.field_name] || PostData[field.field_name] === '')) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] === 'true' ? "Yes" : UserData[0][field.field_name] === 'false' ? "No" : UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name] : ''}
                                                    onChange={(e) => props.type !== 'rejected' && GetCategory() ? handleDataChange(e.target.value, field.field_name, field.field_details) : UserData[0][field.field_name] ? null : handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                    InputLabelProps={{ shrink: true }}
                                                    helperText={ErrorMessage[field.field_name] ? ErrorMessage[field.field_name] : ""}
                                                    sx={{
                                                        input: {
                                                            background: props.type === 'rejected' || GetCategory() === false ? '#e3e3e3' : '#FFFFF2'
                                                        }
                                                    }}
                                                    FormHelperTextProps={{ sx: { color: "red" } }}
                                                    fullWidth
                                                    inputProps={{
                                                        readOnly: props.type === 'rejected' || GetCategory() === false ? true : false,
                                                    }}
                                                />
                                            </Grid>
                                            :
                                            field.field_type === 'Option' || field.field_type === 'Select List' ?
                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index} gap={2}>
                                                    <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{ color: 'red', display: (field.required === 'true' || field.required) ? 'block' : 'none' }}>*</span></Typography>

                                                    <FormControl fullWidth>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            value={(props.type !== 'rejected' && PostData[field.field_name]) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name] : ''}
                                                            inputProps={{
                                                                readOnly: props.type === 'rejected' || GetCategory() === false ? true : false,
                                                            }}
                                                            sx={{
                                                                '& .MuiSelect-select': {
                                                                    background: props.type === 'rejected' || GetCategory() === false
                                                                        ? '#e3e3e3'

                                                                        : '#FFFFF2'
                                                                },
                                                                '& .MuiSelect-icon': props.type === 'rejected' ? {} : {},
                                                            }}
                                                            onChange={(e) => props.type !== 'rejected' && GetCategory() ? handleListChange(e.target.value, field.field_name) : UserData[0][field.field_name] ? null : handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                        >
                                                            <MenuItem sx={{ display: 'none' }} value={UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : ''}>{UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name] : ''}</MenuItem>

                                                            {
                                                                field.field_details.options.map((item, index) => (

                                                                    <MenuItem value={item.value} key={index}>{item.Displayname}</MenuItem>
                                                                ))
                                                            }

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                :
                                                field.field_type === 'Dependent Plugin' ?
                                                    <>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                            <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                                color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                            }}>*</span></Typography>
                                                            <TextField
                                                                variant='outlined'
                                                                value={(props.type === 'rejected' && (PostData[field.field_name] || PostData[field.field_name] === '')) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] === 'true' ? "Yes" : UserData[0][field.field_name] === 'false' ? "No" : UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name] : ''}
                                                                onChange={(e) => props.type !== 'rejected' && GetCategory() ? handleDataChange(e.target.value, field.field_name, field.field_details) : UserData[0][field.field_name] ? null : handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    input: {
                                                                        background: props.type === 'rejected' || GetCategory() === false ? '#FFFFF2' : UserData && UserData[0][field.field_name] ? '#f0f0f0' : '#FFFFF2'
                                                                    }
                                                                }}
                                                                fullWidth
                                                                inputProps={{
                                                                    readOnly: props.type === 'rejected' || GetCategory() === false ? false : UserData && UserData[0][field.field_name] ? true : false,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                            <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_details.dependent_field ? field.field_details.dependent_field.split('_').join(" ") : ""}<span style={{
                                                                color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                            }}>*</span></Typography>
                                                            <TextField
                                                                variant='outlined'
                                                                value={(props.type === 'rejected' && (PostData[field.field_details.dependent_field] || PostData[field.field_details.dependent_field] === '')) ? PostData[field.field_details.dependent_field] : UserData && UserData[0][field.field_details.dependent_field] ? UserData[0][field.field_details.dependent_field] === 'true' ? "Yes" : UserData[0][field.field_details.dependent_field] === 'false' ? "No" : UserData[0][field.field_details.dependent_field] : PostData[field.field_details.dependent_field] ? PostData[field.field_details.dependent_field] : ''}
                                                                onChange={(e) => props.type !== 'rejected' && GetCategory() ? handleDataChange(e.target.value, fieldfield_details.dependent_field, field.field_details) : UserData[0][field.field_details.dependent_field] ? null : handleDataChange(e.target.value, field.field_details.dependent_field, field.field_details)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    input: {
                                                                        background: props.type === 'rejected' || GetCategory() === false ? '#e3e3e3' : UserData && UserData[0][field.field_details.dependent_field] ? '#f0f0f0' : '#FFFFF2'
                                                                    }
                                                                }}
                                                                fullWidth
                                                                inputProps={{
                                                                    readOnly: props.type === 'rejected' || GetCategory() === false ? false : UserData && UserData[0][field.field_details.dependent_field] ? true : false,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </>
                                                    :
                                                    field.field_type === 'Date' ?
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                            <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                                color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                            }}>*</span></Typography>
                                                            <TextField
                                                                variant='outlined'
                                                                value={(props.type !== 'rejected' && props.type !== 'approved' && (PostData[field.field_name] || PostData[field.field_name] === '')) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] === 'true' ? "Yes" : UserData[0][field.field_name] === 'false' ? "No" : UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name] : ''}
                                                                onChange={(e) => props.type !== 'rejected' && GetCategory() ? handleDateChange(e.target.value, field.field_name) : null}
                                                                InputLabelProps={{ shrink: true }}
                                                                type='date'
                                                                sx={{
                                                                    input: {
                                                                        background: props.type === 'rejected' || GetCategory() === false ? '#e3e3e3' : '#FFFFF2'
                                                                    }
                                                                }}
                                                                fullWidth
                                                                onKeyDown={(e)=>e.preventDefault()}
                                                                inputProps={{
                                                                    readOnly: props.type === 'rejected' || GetCategory() === false ? true : false,
                                                                    max: new Date().toISOString().split("T")[0],
                                                                    min:field.field_name==='credential_received_date'?PostData&&PostData['credential_request_date']?PostData['credential_request_date']:UserData&&UserData.length>0&&UserData[0]['credential_request_date']?UserData[0]['credential_request_date']:Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]]['credential_request_date'] ? props.data[Selected["category_name"]]['credential_request_date']:null
                                                                    :
                                                                    field.field_name==='credential_activation_date'?PostData&&PostData['credential_received_date']?PostData['credential_received_date']:UserData&&UserData.length>0&&UserData[0]['credential_received_date']?UserData[0]['credential_received_date']:Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]]['credential_received_date'] ? props.data[Selected["category_name"]]['credential_received_date']:null
                                                                    :
                                                                    null
                                                                    
                                                                }}
                                                            />
                                                        </Grid>
                                                        :
                                                        field.field_type === "Plugin" && field.field_details && field.field_details.button === 'false' ?

                                                            (
                                                                <Grid item md={4} xs={12} key={field.field_id}>
                                                                    <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                                        color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                                    }}>*</span></Typography>
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={ErrorMessage[field.field_name] ? true : false}

                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                background: sessionStorage.getItem(field.field_name) ? '#F9F3FC' : '',
                                                                                '& .MuiFormLabel-asterisk': { color: 'red' }
                                                                            },
                                                                            '& .MuiSelect-select': {
                                                                                background: props.type === 'rejected'

                                                                                    || GetCategory() === false
                                                                                    ? '#e3e3e3'

                                                                                    : '#FFFFF2'
                                                                            },
                                                                            '& .MuiSelect-icon': props.type === 'rejected' ? {} : {},
                                                                        }}
                                                                        required={field.required ? true : false}
                                                                        variant='outlined'
                                                                        size='medium'
                                                                    >

                                                                        <Select
                                                                            labelId="select-label"
                                                                            onChange={(e) => props.type !== 'rejected' && GetCategory() ? handleListChange(e.target.value, field.field_name) : null}
                                                                            disabled={props.type === 'rejected' || GetCategory() === false ? true : false}
                                                                            onFocus={() =>
                                                                                field.field_details.parameters
                                                                                    ? handleDynamicGet(field, field.field_details.parameters, PostData)
                                                                                    : handleDynamicGet(field)
                                                                            }
                                                                            id="select"
                                                                            value={PostData[field.field_name] || PostData[field.field_name] === "" ?
                                                                                PostData[field.field_name]
                                                                                :
                                                                                UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                                                                    UserData[0][field.field_name]
                                                                                    :
                                                                                    Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name]
                                                                                        :

                                                                                        ""}
                                                                            name={field.field_name}
                                                                            sx={{
                                                                                '& .MuiSelect-select': {
                                                                                    background: sessionStorage.getItem(field.field_name) ? '#F9F3FC' : ''
                                                                                }
                                                                            }}
                                                                        >
                                                                            <MenuItem sx={{ visibility: "hidden" }} value={PostData[field.field_name] || PostData[field.field_name] === "" ?
                                                                                PostData[field.field_name]
                                                                                :
                                                                                UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                                                                    UserData[0][field.field_name]
                                                                                    :
                                                                                    Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name]
                                                                                        :
                                                                                        ""}>{PostData[field.field_name] || PostData[field.field_name] === "" ?
                                                                                            PostData[field.field_name]
                                                                                            :
                                                                                            UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                                                                                UserData[0][field.field_name]
                                                                                                :
                                                                                                Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name]
                                                                                                    :
                                                                                                    ""}</MenuItem>
                                                                            {
                                                                                getMatch(field.field_name.toUpperCase(), 'BANK_NAME') ? (
                                                                                    DynamicData && DynamicData.length > 0 ? (
                                                                                        DynamicData.map((item, index) => (
                                                                                            <MenuItem key={index} value={item}>
                                                                                                {item}
                                                                                            </MenuItem>
                                                                                        ))
                                                                                    ) : (
                                                                                        <MenuItem>Loading....</MenuItem>
                                                                                    )
                                                                                )
                                                                                    :
                                                                                    getMatch(field.field_name.toUpperCase(), 'STATE') ? (
                                                                                        DynamicData ? (
                                                                                            Object.entries(DynamicData).map(([key]) => (
                                                                                                <MenuItem key={key} value={key}>
                                                                                                    {key}
                                                                                                </MenuItem>
                                                                                            ))
                                                                                        ) : (
                                                                                            <MenuItem>Loading....</MenuItem>
                                                                                        )
                                                                                    ) : getMatch(field.field_name.toUpperCase(), 'SUB_DISTRICT') ? (
                                                                                        DynamicData && ((PostData && PostData[getKey(PostData, 'DISTRICT')]) || (UserData && UserData.length > 0 && UserData[0][getKey(UserData[0], "SUB_DISTRICT")])) ?
                                                                                            DynamicData &&
                                                                                                PostData[getKey(PostData, 'DISTRICT')] ?
                                                                                                Object.entries(DynamicData).map(([key]) => (
                                                                                                    <MenuItem key={key} value={key}>
                                                                                                        {key}
                                                                                                    </MenuItem>
                                                                                                ))
                                                                                                :
                                                                                                DynamicData &&
                                                                                                    UserData &&
                                                                                                    UserData[0][getKey(UserData[0], "DISTRICT")] ?
                                                                                                    Object.entries(DynamicData).map(([key]) => (
                                                                                                        <MenuItem key={key} value={key}>
                                                                                                            {key}
                                                                                                        </MenuItem>
                                                                                                    ))
                                                                                                    :
                                                                                                    null
                                                                                            : (
                                                                                                <MenuItem>Loading....</MenuItem>
                                                                                            )
                                                                                    ) : getMatch(field.field_name.toUpperCase(), 'DISTRICT') ? (
                                                                                        DynamicData && ((getKey(PostData, 'STATE') && PostData[getKey(PostData, 'STATE')]) || (UserData && Array.isArray(UserData) && UserData[0][getKey(UserData[0], 'STATE')] !== '')) ? (
                                                                                            DynamicData && PostData[getKey(PostData, 'STATE')] ?
                                                                                                DynamicData[PostData[getKey(PostData, 'STATE')]] &&
                                                                                                DynamicData[PostData[getKey(PostData, 'STATE')]].map((item, index) => (
                                                                                                    <MenuItem key={index} value={item}>
                                                                                                        {item}
                                                                                                    </MenuItem>
                                                                                                ))
                                                                                                :
                                                                                                DynamicData && DynamicData[UserData[0][getKey(UserData[0], 'STATE')]] && UserData && UserData.length > 0 ?
                                                                                                    // console.log("test",DynamicData[UserData[0][getKey(UserData[0], 'STATE')]])
                                                                                                    DynamicData[UserData[0][getKey(UserData[0], 'STATE')]].map((item, index) => (
                                                                                                        <MenuItem key={index} value={item}>
                                                                                                            {item}
                                                                                                        </MenuItem>
                                                                                                    ))
                                                                                                    :
                                                                                                    (
                                                                                                        <MenuItem>Loading....</MenuItem>
                                                                                                    )
                                                                                        ) : (
                                                                                            <MenuItem>Loading....</MenuItem>
                                                                                        )
                                                                                    ) : getMatch(field.field_name.toUpperCase(), 'VILLAGE') ? (
                                                                                        DynamicData &&
                                                                                            PostData &&
                                                                                            getKey(PostData, 'SUB_DISTRICT') &&
                                                                                            PostData[getKey(PostData, 'SUB_DISTRICT')] ? (
                                                                                            DynamicData &&
                                                                                            PostData[getKey(PostData, 'SUB_DISTRICT')] &&
                                                                                            DynamicData[PostData[getKey(PostData, 'SUB_DISTRICT')]] &&
                                                                                            DynamicData[PostData[getKey(PostData, 'SUB_DISTRICT')]].map((item, index) => (
                                                                                                <MenuItem key={index} value={item}>
                                                                                                    {item}
                                                                                                </MenuItem>
                                                                                            ))
                                                                                        ) 
                                                                                        :
                                                                                        DynamicData&&UserData&&UserData.length>0&&UserData[0][getKey(UserData[0], 'SUB_DISTRICT')] ? (
                                                                                            DynamicData[UserData[0][getKey(UserData[0], 'SUB_DISTRICT')]]&&
                                                                                            DynamicData[UserData[0][getKey(UserData[0], 'SUB_DISTRICT')]].map((item, index) => (
                                                                                                <MenuItem key={index} value={item}>
                                                                                                    {item}
                                                                                                </MenuItem>
                                                                                            ))
                                                                                        )
                                                                                        : 
                                                                                        (
                                                                                            <MenuItem>Loading....</MenuItem>
                                                                                        )
                                                                                    ) : getMatch(field.field_name.toUpperCase(), 'EA_AGENCY') ? (
                                                                                        DynamicData &&
                                                                                        DynamicData.aec_admin_data &&
                                                                                        DynamicData.aec_admin_data.map((item, index) => (
                                                                                            <MenuItem key={index} value={item.agency_name}>
                                                                                                {item.agency_name}
                                                                                            </MenuItem>
                                                                                        ))
                                                                                    )
                                                                                        : (
                                                                                            <MenuItem>no match</MenuItem>
                                                                                        )

                                                                                // DynamicData ?
                                                                                //   DynamicData.map((item, index) => (
                                                                                //     <MenuItem key={index}>{item}</MenuItem>
                                                                                //   ))
                                                                                //   :
                                                                                //   <MenuItem>Loading....</MenuItem>
                                                                            }
                                                                        </Select>


                                                                    </FormControl>
                                                                </Grid>
                                                            )
                                                            :
                                                            (field.field_type === "Plugin" && field.field_details && field.field_details.button !== 'false') ?
                                                                <Grid item md={4} xs={12} key={field.field_id}>
                                                                    <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                                        color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                                    }}>*</span></Typography>
                                                                    <TextField

                                                                        type="text"
                                                                        variant='outlined'
                                                                        value={PostData[field.field_name] || PostData[field.field_name] === "" ?
                                                                            PostData[field.field_name]
                                                                            :
                                                                            UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                                                                UserData[0][field.field_name]
                                                                                :
                                                                                Selected && props.data && props.data[Selected["category_name"]] && props.data[Selected["category_name"]][field.field_name] ? props.data[Selected["category_name"]][field.field_name]
                                                                                    :
                                                                                    ""}
                                                                        name={field.field_name}
                                                                        fullWidth
                                                                        onChange={(e) => handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                                        // onBlur={handleBlur}
                                                                        // onInput={handleAccNOInput}
                                                                        sx={{
                                                                            input: {
                                                                                background: (VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified) || (props.type === 'rejected' || GetCategory() === false) ? '#e3e3e3' : '#FFFFF2'
                                                                            }
                                                                        }}
                                                                        inputProps={{
                                                                            readOnly: props.type === 'rejected' || GetCategory() === false ? true : false
                                                                        }}
                                                                        InputLabelProps={
                                                                            {
                                                                                shrink: true,
                                                                            }
                                                                        }
                                                                        disabled={
                                                                            VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified ? true : false
                                                                        }
                                                                        InputProps={
                                                                            {
                                                                                endAdornment: (
                                                                                    <Button
                                                                                        component="label"
                                                                                        // role={undefined}
                                                                                        variant="outlined"
                                                                                        disabled={
                                                                                            // sessionStorage.getItem(field.field_name) ? true : false
                                                                                            (VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified) || (props.type === "rejected" || GetCategory() === false) ? true : false
                                                                                        }
                                                                                        color={PostData[`${field.field_name}_verify`] === 'true' ? 'success' : 'secondary'}
                                                                                    // onClick={()=>handlePluginButton(field.field_name,values,field.field_details,setFieldValue)}
                                                                                    >
                                                                                        {field.field_details.button}
                                                                                        <VisuallyHiddenInput
                                                                                            name={PostData[field.field_name]}
                                                                                            onClick={() =>
                                                                                                PostData[`${field.field_name}_verify`] === 'true'
                                                                                                    ? null
                                                                                                    : handlePluginButton(
                                                                                                        field.field_name,
                                                                                                        PostData,
                                                                                                        field.field_details,

                                                                                                    )
                                                                                            }
                                                                                        />
                                                                                    </Button>
                                                                                )
                                                                            }
                                                                        }


                                                                    // onChange={(e) => handleFileUpload(item.name, e.target.files[0])}
                                                                    />

                                                                </Grid>
                                                                :
                                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index} gap={2}>
                                                                    <table style={{ width: '100%' }}>
                                                                        <tr>
                                                                            <th style={{ textAlign: 'left' }}>
                                                                                <Stack direction='column'>
                                                                                    <Stack direction='row'><span>{field.field_display_name}</span><span style={{ color: 'red' }}>{field.required ? "*" : ''}</span></Stack>
                                                                                    <Typography variant='h6' sx={{ fontWeight: 400 }} color="#bfbfbf">Max file size: 5MB, formats: .jpg/.png/.pdf</Typography>
                                                                                    <Stack direction='row' spacing={1}>
                                                                                        <Button
                                                                                            size='small'
                                                                                            variant='outlined'
                                                                                            disabled={UserData && UserData[0][field.field_name] ? false : true}
                                                                                            color='secondary' onClick={() => handleViewFile(field.field_name)}
                                                                                            sx={{ borderRadius: '5px' }}>View</Button>

                                                                                        <Divider orientation="vertical" flexItem />

                                                                                        <Button
                                                                                            component="label"
                                                                                            role={undefined}
                                                                                            variant="contained"
                                                                                            tabIndex={-1}
                                                                                            color='secondary'
                                                                                            sx={{ borderRadius: '5' }}
                                                                                            size='small'
                                                                                            disabled={props.type === 'rejected' || GetCategory() === false ? true : false}
                                                                                        >
                                                                                            Upload
                                                                                            <VisuallyHiddenInput type="file" onChange={(e) => handleFileReupload(field.field_name, e.target.files[0])} />
                                                                                        </Button>

                                                                                        <Divider orientation="vertical" flexItem />

                                                                                        <Button
                                                                                            size='small'
                                                                                            variant='contained'
                                                                                            disabled={UserData && UserData[0][field.field_name] ? false : true}
                                                                                            color='warning' onClick={() => handleDownloadFile(field.field_name, field.field_display_name)}
                                                                                            sx={{ borderRadius: '5px' }}><IoMdDownload /></Button>


                                                                                    </Stack>
                                                                                </Stack></th>
                                                                            <th style={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>

                                                                            </th>
                                                                        </tr>
                                                                    </table>
                                                                </Grid>

                                    ))
                                }
                                {
                                    Selected.category_name === "kyc_documents" ?
                                        <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }} mt={5}>
                                            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>

                                                <Button
                                                    variant='text'
                                                    color='secondary'
                                                    sx={{ borderRadius: '5px', marginLeft: 2 }}
                                                    disabled={Selected ? false : true}
                                                    onClick={() => handleFileDownloadAll()}
                                                    fullWidth
                                                >
                                                    Download All
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        :
                                        null

                                }
                                <Grid container mt={1}>
                                    <Grid item xs={12}>
                                        <Stack direction="row" justifyContent="center" alignItems="center">
                                            {
                                                props.type !== 'rejected' ?

                                                    <Button variant='contained' disabled={IsError || IsEmpty()} color='secondary' onClick={() => handleSubmit()}>Save</Button>
                                                    :
                                                    null
                                            }
                                        </Stack>
                                    </Grid>
                                </Grid>


                            </Grid>
                            :
                           
                                <table style={{ width: '70%' }}>
                                    {
                                        FilteredData && FilteredData.map((filtered, index) => (

                                            <tr key={index}>
                                                <td>{filtered.category_display_name}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-start' }}>{<Button variant='contained'  color='secondary' size='small' onClick={() => handleFormOpen(filtered)}>view</Button>}</td>
                                            </tr>



                                        ))



                                    }
                                </table>
                              
                    }

                </DialogContent>

                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>

                    {
                        props.type === 'pending' || props.type === 'rejected' ?
                            <Button sx={{ display: Selected ? 'none' : 'flex', visibility: "hidden" }} disabled={Array.isArray(AllData) && AllData.length > 0 ? false : true} onClick={() => handleApproveRequest()} color="success" variant='contained'>
                                {Array.isArray(AllData) && AllData.length > 0 ? "Approve" : "Loading..."}
                            </Button>
                            :
                            null
                    }


                </DialogActions>

            </Dialog>
        </React.Fragment>
    );
}
